var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
export var ErrorType;
(function (ErrorType) {
    ErrorType["Retriable"] = "Retriable";
    ErrorType["NonRetriable"] = "NonRetriable";
    ErrorType["SystemError"] = "SystemError";
})(ErrorType || (ErrorType = {}));
var errorVerbiage = (_a = {},
    _a[ErrorType.Retriable] = 'Payment could not be processed. Please review your card information and try again.',
    _a[ErrorType.NonRetriable] = 'Payment could not be processed. Please enter a different payment method and try again.',
    _a[ErrorType.SystemError] = 'Payment could not be processed. Please try again.',
    _a);
var PaymentError = /** @class */ (function (_super) {
    __extends(PaymentError, _super);
    function PaymentError(type, message, additionalData) {
        if (message === void 0) { message = errorVerbiage[ErrorType.NonRetriable]; }
        var _this = _super.call(this, message) || this;
        _this.message = message || '';
        _this.type = type || ErrorType.Retriable;
        _this.reason = additionalData === null || additionalData === void 0 ? void 0 : additionalData.reason;
        _this.bgCode = additionalData === null || additionalData === void 0 ? void 0 : additionalData.bgCode;
        Object.setPrototypeOf(_this, PaymentError.prototype);
        return _this;
    }
    PaymentError.parsePaymentFailure = function (baseResponse, error) {
        if (error instanceof PaymentError) {
            return __assign(__assign({}, baseResponse), { status: 'error', ok: false, reason: error.reason, message: error.message, bgCode: error.bgCode });
        }
        return __assign(__assign({}, baseResponse), { status: 'error', ok: false, reason: error.message, message: error.message });
    };
    return PaymentError;
}(Error));
export { PaymentError };
var AddressErrorType;
(function (AddressErrorType) {
    AddressErrorType["InvalidValue"] = "InvalidValue";
})(AddressErrorType || (AddressErrorType = {}));
var AddressFields;
(function (AddressFields) {
    AddressFields["address1"] = "address1";
    AddressFields["address2"] = "address2";
    AddressFields["city"] = "city";
    AddressFields["stateOrProvince"] = "stateOrProvince";
    AddressFields["postalCode"] = "postalCode";
})(AddressFields || (AddressFields = {}));
var addressErrorMapping = (_b = {},
    _b[AddressFields.address1] = 'Address is invalid. Please enter a valid address',
    _b[AddressFields.address2] = 'Address 2 is invalid. Please enter a valid address2',
    _b[AddressFields.city] = 'City is invalid. Please enter a valid city name',
    _b[AddressFields.stateOrProvince] = 'State/Province is invalid. Please enter a valid state/province',
    _b[AddressFields.postalCode] = 'Postal code is invalid. Please enter a valid postal/zip code',
    _b);
var errorCodeMapping = {
    503: ErrorType.SystemError,
    504: ErrorType.SystemError,
    400: ErrorType.NonRetriable,
    422: ErrorType.NonRetriable,
    404: ErrorType.NonRetriable
};
// TODO: these needs reassesment. Our NonRetirable and Retriable definition are broad/general
// but if we refer to this ticket: https://enterprise-jira.prod.asurion.net/browse/BG-14236
// those NonRetriable & Retriable verbiage only points
// to card/payment information being invalid or declined
var errorMessageMapping = {
    'Failed to fetch': ErrorType.Retriable,
    'Something went wrong': ErrorType.Retriable,
    'Unsupported vendor for application session. Adyen only supported for now.': ErrorType.NonRetriable,
    'NetworkError when attempting to fetch resource.': ErrorType.Retriable,
    'Not Found': ErrorType.SystemError,
    'Session completed, billing token already created': ErrorType.SystemError,
    'Session Expired': ErrorType.SystemError,
    "Session doesn't have any payment methods.": ErrorType.SystemError
};
export var ErrorHandling = function (statusCode, message, bgCode) {
    var errorType = ErrorType.NonRetriable;
    if (statusCode) {
        errorType = errorCodeMapping[statusCode] || ErrorType.Retriable;
    }
    // superior if message are provided since we have defined more than statusCode
    if (message) {
        errorType = errorMessageMapping[message] || ErrorType.NonRetriable;
    }
    var errorMessage = errorVerbiage[errorType];
    var additionalData = { reason: message, bgCode: bgCode };
    return new PaymentError(errorType, errorMessage, additionalData);
};
export var AddressErrorHandling = function (addressValidityResult) {
    if (addressValidityResult.isValid) {
        return {};
    }
    var addressValidityValues = __assign({}, addressValidityResult);
    delete addressValidityValues['isValid'];
    var mappedErrorResponse = Object.entries(addressValidityValues).reduce(function (previousValue, currentValue) {
        var _a;
        var addressField = currentValue[0], isFieldValid = currentValue[1];
        return isFieldValid
            ? previousValue
            : __assign(__assign({}, previousValue), (_a = {}, _a[addressField] = { type: AddressErrorType.InvalidValue, message: addressErrorMapping[addressField] }, _a));
    }, {});
    return mappedErrorResponse;
};
